import React, { useEffect, useRef, useState } from 'react';
import { Modal, Box, Button, Typography, Stack, Tooltip, OutlinedInput } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { APIUrlThree, APIUrlToken, GetUserId } from "../../../Utils/Utils";
import axios from "axios";
import { toast } from "react-toastify";
import halflines from "../../../Assets/halflines.svg";
import search from "../../../Assets/search.svg";
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { useLocation, useParams } from 'react-router-dom';
import download from "../../../Assets/downloadcv.png";
import html2pdf from "html2pdf.js";
import { useReactToPrint } from "react-to-print";
import print from "../../../Assets/print.svg";
import Loader from '../../Loader/Loader';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import KeywordFilterModal from '../../CompetitiveIntelligence/KeywordFilterModal';
import KeywordFilterModalBre from './KeywordFilterBreModal';
import { CloseOutlined } from '@mui/icons-material';

const NewsEventsBre = ({ expandedRowId, downloadToPDF }) => {

    const boxOneRef = useRef();
    const [loading, setLoading] = React.useState(false);
    const [feedBoxOne, setFeedBoxOne] = React.useState([]);
    const [openSearchOne, setOpenSearchOne] = useState(false);
    const [dateOrderOne, setDateOrderOne] = React.useState('desc');
    const [saveSearchOne, setSaveSearchOne] = useState([""]);
    const [newsId, setNewsId] = useState("");
    const [expandedSummaryOne, setExpandedSummaryOne] = useState({});
    const [allExpanded, setAllExpanded] = useState(false);
    const [keywordAddModalOne, setKeywordAddModalOne] = useState(false);

    const [keywordListOne, setKeywordListOne] = useState([]);

    const [keywordSelectedOne, setKeywordSelectedOne] = useState([]);

    const ExpandAllSummary = (value) => {
        setAllExpanded(value)
        let data = feedBoxOne?.reduce((acc, _, index) => {
            acc[index] = value;
            return acc;
        }, {});
        setExpandedSummaryOne(data)
    }

    const toggleSummaryOne = (index) => {
        setExpandedSummaryOne((prevState) => ({
            ...prevState,
            [index]: !prevState[index],
        }));
    };
    const [skipOne, setSkipOne] = useState(0)
    const [loadOne, setLoadOne] = useState(true)
    const [searchOneApi, setSearchOneApi] = useState(false)
    const orgId = expandedRowId?.org_id;



    const getNews = (type) => {
        setLoading(true);

        let keywordQuery = `${keywordSelectedOne?.length ? "&tags=" : ""}${keywordSelectedOne?.length ? keywordSelectedOne : ""}`;

        const options = {
            method: "POST",
            headers: {
                "access-control-allow-origin": "*",
                "X-API-Key": APIUrlToken(),
            },
            url: `${APIUrlThree()}/v1/get_bre_request_news?sort_order=${dateOrderOne}&request_type=bre_request&org_id=${orgId}&limit=10&skip=${type === "date" ? 0 : skipOne}${keywordQuery}`,
        };

        axios(options)
            .then((e) => {
                const sortedData = e?.data?.data?.sort((a, b) => {
                    return dateOrderOne === 'asc'
                        ? new Date(a.article.date) - new Date(b.article.date)
                        : new Date(b.article.date) - new Date(a.article.date);
                });

                if (sortedData.length < 10) {
                    setLoadOne(false);
                } else {
                    setLoadOne(true);
                }

                if (type === "date") {
                    setFeedBoxOne(sortedData.length ? [...sortedData] : []);
                } else {
                    setFeedBoxOne(sortedData.length ? [...feedBoxOne, ...sortedData] : [...feedBoxOne]);
                }

                setKeywordListOne(e?.data?.tags || []);
                setLoading(false);
            })
            .catch((error) => {
                setLoading(false);
                toast.error(error?.response?.data?.message);
            });
    };

    useEffect(() => {
        if (skipOne > 0 && !searchOneApi) {
            getNews()
        } else if (skipOne > 0 && searchOneApi) {
            handleSearchSave()
        }
    }, [skipOne])



    useEffect(() => {
        if (keywordSelectedOne?.length && !searchOneApi) {
            getNews("date");
        } else {
        }
    }, [keywordSelectedOne?.length]);

    useEffect(() => {
        if ((dateOrderOne && !searchOneApi) || downloadToPDF === true) {
            setSkipOne(0)
            getNews('date')
        }
    }, [dateOrderOne, searchOneApi, downloadToPDF])

    // const handleChangeFeedBoxOne = (event) => {
    //     setDateOrderOne(event.target.value);
    // };

    const handleChangeFeedBoxOne = (event) => {
        setDateOrderOne(event.target.value);
        getNews("date"); // Call getNews to fetch data with the new sorting order
    };

    const handleSearchSave = (e) => {
        const data = [saveSearchOne];
        const skipVal = skipOne;
        setLoading(true);
        const options = {
            method: "POST",
            headers: {
                "access-control-allow-origin": "*",
                "X-API-Key": APIUrlToken(),
                "Content-Type": "application/json",
            },
            data: data,
            url: `${APIUrlThree()}/v1/search_news?&org_id=${orgId}&limit=10&skip=${e == 1 ? 0 : skipVal}&search_term=${saveSearchOne}`,
        };
        axios(options)
            .then((response) => {
                if (response?.data?.length < 10) {
                    setLoadOne(false)
                } else {
                    setLoadOne(true)
                }
                if (e == 1) {
                    setSearchOneApi(true)
                    setFeedBoxOne(response.data)
                } else {
                    setFeedBoxOne((prev) => [...prev, ...response.data])
                }
                setLoading(false);
            })
            .catch((error) => {
                setLoading(false);
                toast.error(error?.response?.data?.message);
            });
    };
    useEffect(() => {
        if (saveSearchOne?.length > 3) {
            setKeywordSelectedOne([])
            handleSearchSave(1)
        }
    }, [saveSearchOne])
    const handleRemoveTags = (item) => {
        let data = keywordSelectedOne.filter((keyword) => keyword.toLowerCase() !== item.toLowerCase())
        setKeywordSelectedOne(data);
        if (!data?.length) {
            getNews("date");
        }
    }
    const truncateText = (text) => {
        return text?.length > 13 ? text?.slice(0, 13) + '...' : text;
    };
    const initialData = (item) => {
        const data = item?.split(" ")
        return `${data?.[0]?.charAt(0).toUpperCase() || ""}${data?.[1]?.charAt(0).toUpperCase() || ""}`
    }
    return (
        <>
            {loading ? <Loader /> : null}
            <div className='add-contents-cards-bre'>
                {
                    feedBoxOne ?
                        <div className='CI-cards-content-bre' style={{ pageBreakInside: "avoid" }}>
                            <div className='adding-content' style={{ pageBreakInside: "avoid" }}>
                                <div className='two-head-comp'>

                                    <div className='result-date-icon-comp-bre' style={{ pageBreakInside: "avoid" }}>
                                        <div className='checkbox-result-tag-comp'>
                                            <img src={halflines} alt="" />
                                            <p className='sorted-by-comp'>Sorted by:</p>
                                            <div className='acc-dec-btn-main-bre'>
                                                <FormControl sx={{ m: 1, minWidth: 120 }} className='date-comp-dropdown'>
                                                    <Select className='date-comp-select'
                                                        value={dateOrderOne}
                                                        onChange={handleChangeFeedBoxOne}
                                                        displayEmpty
                                                        input={<OutlinedInput
                                                            notched={false}
                                                            classes={{ notchedOutline: 'custom-fieldset-class', input: 'custom-select-input-class' }}
                                                        />}
                                                        inputProps={{ 'aria-label': 'Without label' }}
                                                    >

                                                        <MenuItem value="asc" className='date-comp-em'>Ascending </MenuItem>
                                                        <MenuItem value="desc" className='date-comp-em'>Descending </MenuItem>
                                                    </Select>
                                                </FormControl>
                                            </div>
                                            {
                                                allExpanded ?
                                                    <div onClick={() => ExpandAllSummary(false)} className="news_all_expand-bre">Collapse All</div> :
                                                    <div onClick={() => ExpandAllSummary(true)} style={{ display: "flex" }} className="news_all_expand-bre">Expand All</div>
                                            }

                                            <div>
                                                {/* <div style={{ position: 'relative' }}>

                                                    <button className="keyword-filter-btn" disabled={searchOneApi} onClick={() => setKeywordAddModalOne(true)}>Keyword Filter <ArrowDropDownIcon /></button>
                                                    {
                                                        keywordAddModalOne === true ?

                                                            <KeywordFilterModalBre setKeywordAddModal={setKeywordAddModalOne}
                                                                dataList={keywordListOne}
                                                                setFeedBox={setKeywordSelectedOne}
                                                                feedBox={keywordSelectedOne}

                                                            /> : null
                                                    }
                                                </div> */}

                                                <div style={{ position: 'relative' }}>
                                                    <button className="keyword-filter-btn" disabled={searchOneApi} onClick={() => setKeywordAddModalOne(true)}>Keyword Filter <ArrowDropDownIcon /></button>
                                                    {
                                                        keywordAddModalOne === true ?

                                                            <KeywordFilterModal setKeywordAddModal={setKeywordAddModalOne}
                                                                setFeedBox={setKeywordSelectedOne}
                                                                feedBox={keywordSelectedOne} /> : null
                                                    }
                                                </div>
                                            </div>
                                            <div className='total-result-brenews'>{feedBoxOne?.length} {feedBoxOne?.length < 2 ? "Result" : "Results"}</div>

                                        </div>
                                        <div className="search_news_container">
                                            <div
                                                style={{ display: 'flex' }}
                                                className={
                                                    openSearchOne
                                                        ? "wrap-search-news active"
                                                        : "wrap-search-news"
                                                }
                                            >
                                                <input
                                                    type="text"
                                                    className={
                                                        openSearchOne
                                                            ? "input_search_news active"
                                                            : "input_search_news"
                                                    }
                                                    placeholder="Search..."
                                                    value={saveSearchOne}
                                                    onChange={(e) => setSaveSearchOne(e?.target?.value)}
                                                    // autoFocus
                                                />
                                                {openSearchOne ? (
                                                    <CloseIcon
                                                        className="threedot-icon-comp"
                                                        onClick={() => {
                                                            setOpenSearchOne(false);
                                                            setSearchOneApi(false);
                                                            setSaveSearchOne("");
                                                            // getNews(feedBoxOne?.boxData, "date");
                                                        }}
                                                    />
                                                ) : (
                                                    <img
                                                        src={search}
                                                        alt=""
                                                        onClick={() => {
                                                            setOpenSearchOne(true);
                                                        }}
                                                    />
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div ref={boxOneRef} >
                                    {
                                        keywordSelectedOne?.length ? <div className='display-kw-ci'>
                                            {
                                                keywordSelectedOne?.map((item) => (
                                                    <div className='crie_selected_names'>{item} <CloseOutlined onClick={() => handleRemoveTags(item)} /></div>
                                                ))
                                            }
                                        </div> : null
                                    }
                                    {feedBoxOne?.length ? <>
                                        {feedBoxOne?.map((articleData, index) => (
                                            <div key={index} className='rest-cont' style={{ pageBreakInside: "avoid" }}>
                                                <div className='joi-circle-text-comp'>
                                                    <div className='jo-icon-comp'><p>{expandedRowId?.org_name ? initialData(expandedRowId?.org_name) : expandedRowId?.org_name}</p></div>
                                                    <div className='date-name-csoon'>
                                                        <div><p className='jobsohio-name-comp'>{articleData?.article?.title?.length > 100
                                                            ? articleData?.article?.title.slice(0, articleData?.article?.title.slice(0, 100).lastIndexOf(" ")) + "..."
                                                            : articleData?.article?.title}
                                                        </p></div>
                                                        <div className="both-news-time-comp">
                                                            <p className="news-comp">
                                                                <a
                                                                    href={articleData?.article?.url}
                                                                    target="_blank"
                                                                    rel="noopener noreferrer"
                                                                >
                                                                    {
                                                                        articleData?.article?.url
                                                                            ? (articleData.article.url.split('https://')[1]?.length > 50
                                                                                ? articleData.article.url.split('https://')[1].slice(0, 50) + '...'
                                                                                : articleData.article.url.split('https://')[1])
                                                                            : ''
                                                                    }
                                                                </a>
                                                                |
                                                            </p>                              <p className="today-comp">
                                                                {new Date(
                                                                    articleData?.article?.date
                                                                ).toLocaleDateString("en-US", {
                                                                    month: "long",
                                                                    day: "numeric",
                                                                    year: "numeric",
                                                                })}
                                                                {/* {articleData?.article?.date} */}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='content-pera-comp'>
                                                    <p className="bold-content-pera-comp">
                                                        {
                                                            downloadToPDF === true ? articleData?.summary :
                                                                <>
                                                                    {
                                                                        expandedSummaryOne[index] ? (
                                                                            <>
                                                                                {articleData.summary}
                                                                                {articleData.summary.length > 400 && (
                                                                                    <span
                                                                                        onClick={() => toggleSummaryOne(index)}
                                                                                        className="see-more-btn"
                                                                                        style={{
                                                                                            color: "#DA291C",
                                                                                            cursor: "pointer",
                                                                                            textDecoration: "none",
                                                                                            paddingLeft: "5px"
                                                                                        }}
                                                                                    >
                                                                                        Show Less
                                                                                    </span>
                                                                                )}
                                                                            </>
                                                                        ) : (
                                                                            <>
                                                                                {articleData.summary.length > 400
                                                                                    ? `${articleData.summary.slice(0, articleData.summary.lastIndexOf(' ', 400))}`
                                                                                    : articleData.summary}
                                                                                {articleData.summary.length > 400 && (
                                                                                    <span
                                                                                        onClick={() => toggleSummaryOne(index)}
                                                                                        className="see-more-btn"
                                                                                        style={{
                                                                                            color: "#DA291C",
                                                                                            cursor: "pointer",
                                                                                            textDecoration: "none",
                                                                                            paddingLeft: "5px"
                                                                                        }}
                                                                                    >
                                                                                        See More
                                                                                    </span>
                                                                                )}
                                                                            </>
                                                                        )

                                                                    }
                                                                </>
                                                        }

                                                    </p>
                                                    <div className="Intersect-jb-nf-comp">
                                                        {articleData?.tags?.map((tag, idx) => (
                                                            <p key={idx}>{tag}</p>
                                                        ))}
                                                        {/* <p className="save-button-dash" onClick={() => setOpenTagModal({ articleData: articleData, data: feedBoxOne?.boxData?.content_box_id })}>Add tag</p> */}
                                                    </div>
                                                </div>
                                                <hr className='hr-tag-ci' />
                                            </div>
                                        ))}
                                    </> : <p className='text-center-result'>No results found</p>}
                                </div>
                            </div>
                            {/* {
                                loadOne ?
                                    <div className='dash-cancel-save-btns'>
                                        <Button className='de_next' onClick={() => setSkipOne(skip => skip + 10)}>Load More</Button>
                                    </div> : null
                            } */}
                        </div> : <div className='CI-cards-content'><div style={{ display: "flex", justifyContent: "center", alignItems: "center", padding: "20px" }}>Data Not Available </div></div>
                }

            </div>

        </>
    );
};
export default NewsEventsBre; 
